<template>
  <div class="child" :style="{ height: lineheight + 'px' }" :class="{ selected: isEditing }">
    <div class="partBarHolder">
      <v-touch
        @panmove="onPanMove"
        @panstart="onPanStart"
        @panend="onPanEnd"
        v-bind:pan-options="{ direction: 'horizontal', threshold: 2 }"
      >
        <div
          class="partComponent partBar"
          @click="(selectionAllowed && selectPart(part)) || null"
          :class="[{ moreLeft: left < 0 }, alertIndicator]"
          :style="{
            height: lineheight - 3 + 'px',
            lineHeight: lineheight - 3 + 'px',
            left: leftPos,
            width: width,
            backgroundColor: part.colour,
            cursor: draggingAllowed ? 'move' : 'pointer',
          }"
        >
          &nbsp;
          <span ref="bar" class="partBarTitle" :style="{ cursor: draggingAllowed ? 'col-resize' : 'inherit' }">
            {{ part.title }}</span
          >
        </div>
        <div
          v-if="deliveryPos > 0"
          class="partComponent partDelivery"
          :class="[alertIndicator, deliveryStatusCss]"
          :style="{ left: deliveryPos + 'px', top: lineheight - 20 + 'px' }"
        >
          <b-icon icon="truck" />
        </div>
      </v-touch>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import contextMenu from 'vue-context-menu';
import { EventBus } from '@/common/eventbus';

export default {
  name: 'Part',
  data() {
    return {
      panStart: moment(),
      panType: '',
      panDate: moment(),
      lock: false,
    };
  },
  props: [
    'filterDate',
    'filterDateZoom',
    'level',
    'lineheight',
    'lockedDragNDrop',
    'part',
    'showAlerts',
    'stage',
    'treeChild',
  ],
  watch: {
    filterDateZoom: function (newValue) {
      if (this.isEditing) {
        this.focusPart();
      }
    },
    selectedPart: function (newPart) {
      if (newPart && this.part._id === newPart._id) {
        console.log('part selected watched', newPart);
        this.focusPart();
      }
    },
  },
  methods: {
    ...mapActions(['savePartProperties', 'selectPart']),
    onPanStart: function (e) {
      if (!this.draggingAllowed) {
        return;
      }

      if (e.target.tagName === 'SPAN') {
        this.panStart = moment(this.part.expectedDonedate);
        this.panType = 'expectedDonedate';
      } else {
        this.panType = 'startdate';
        this.panStart = moment(this.part.startdate);
      }
    },
    onPanEnd: function (e) {
      if (!this.draggingAllowed) {
        return;
      }
      if (this.panType === 'expectedDonedate') {
        this.savePartProperties({
          updatePart: this.part,
          newPartProperties: { expectedDonedate: this.panDate.format('YYYY-MM-DD') },
        });
      } else {
        this.savePartProperties({
          updatePart: this.part,
          newPartProperties: { startdate: this.panDate.format('YYYY-MM-DD') },
        });
      }
      this.panType = '';
    },
    onPanMove: function (e) {
      if (!this.draggingAllowed) {
        return;
      }

      if (this.panType === 'expectedDonedate') {
        this.panDate = moment(this.panStart).add(
          e.deltaX / (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor),
          'days'
        );
      } else {
        this.panDate = moment(this.panStart).add(
          e.deltaX / (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor),
          'days'
        );
      }
    },
    focusPart: function () {
      console.log('part.focus', this.left, this.$refs['bar']);
      if (this.$refs['bar'].scrollIntoViewIfNeeded) {
        this.$refs['bar'].scrollIntoViewIfNeeded();
      }
    },
  },
  computed: {
    ...mapGetters([
      'username',
      'selectedPart',
      'currentProject',
      'viewSettings',
      'projectDraggingAllowed',
      'hasSimplePermissions',
    ]),
    alertIndicator: function () {
      return this.showAlerts ? this.treeChild.alert.css : '';
    },
    draggingAllowed: function () {
      return !this.lockedDragNDrop && this.projectDraggingAllowed;
    },
    selectionAllowed() {
      return this.hasSimplePermissions('selectPart');
    },
    isEditing: function (state, getters) {
      return state.selectedPart != null && state.selectedPart._id === this.part._id;
    },
    leftPos: function () {
      var leftPos = this.left;
      if (leftPos < 0) {
        leftPos = 0;
      }

      return leftPos + 'px';
    },
    left: function () {
      var start = this.panType === 'startdate' ? this.panDate : moment(this.part.startdate);
      var first = moment(this.filterDate);
      var left =
        (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor * (start - first)) / (1000 * 60 * 60 * 24);

      return left;
    },
    deliveryPos: function () {
      if (this.part.deliverydate > '0001-01-01' && this.panType !== 'startdate') {
        var start = moment(this.part.deliverydate);
        var first = moment(this.filterDate);
        var left =
          (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor * (start - first)) / (1000 * 60 * 60 * 24);

        return left;
      }
      return 0;
    },
    /**
     * Return css class for delivery based on status: fulfilled, late, pending.
     */
    deliveryStatusCss: function () {
      if (this.part.deliveryFulfilled) {
        return 'delivery-fulfilled';
      }
      if (moment(this.part.deliverydate).isBefore(moment())) {
        return 'delivery-late';
      }
      return 'delivery-pending';
    },
    width: function () {
      var calendarTime =
        this.panType === 'expectedDonedate'
          ? this.panDate.diff(this.part.startdate, 'day') + 1
          : this.part.calendarTime;
      var left = this.left;
      var width = calendarTime * this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor + Math.min(0, left);
      if (width < 10) {
        width = 10;
      }
      return width + 'px';
    },
  },
  components: {
    contextMenu,
  },
  mounted: function () {
    EventBus.$on('focusPart', (part) => {
      if (part._id === this.part._id) {
        this.focusPart();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('focusPart');
  },
};
</script>

<style scoped>
.child {
  border-bottom: 1px solid #aaaaaa;
  z-index: 100;
}

.part {
  background: white;
  text-align: left;

  position: relative;
  border: 1px solid grey;
}
.moreLeft {
  background-color: #eee;
  text-overflow: clip;
}
.moreLeft::before {
  content: '«';
}
.partComponent {
  white-space: nowrap;
  display: inline-block;
  position: absolute;
  margin: 0px;
  vertical-align: top;
}

.partDelivery {
  top: -0px;
  font-size: 90%;
  text-shadow: 0px 0px 4px #fff;
}
.partBarHolder {
  display: inline-block;
  position: absolute;
  overflow: visible;
}
.partBar {
  box-sizing: border-box;
  background: #091d2e;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  font-size: 10px;
  white-space: nowrap;
  margin-top: 1px;
}

.partBar span {
  margin-left: 5px;
  left: 100%;
  position: absolute;
  font-weight: bold;
}

.partBar.selected {
  background-color: red;
}

.partBar.warning {
  animation-name: warningpulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.partBar.error {
  animation-name: errorpulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.partBar.ok {
  animation-name: okpulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.partDelivery.warning {
  animation-name: warningpulsefg;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.partDelivery.error {
  animation-name: errorpulsefg;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.partDelivery.ok {
  animation-name: okpulsefg;
  animation-iteration-count: infinite;
  animation-duration: 2s;
}

.child.selected {
  background-color: #cccccc;
}

.delivery-late {
  color: #990000;
}
.delivery-fulfilled {
  opacity: 0.3;
}
.delivery-pending {
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/Part.vue